export const polarToCartesian = (
    centerX: number,
    centerY: number,
    radius: number,
    angleInDegrees: number
) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180;

    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
};

/**
 * Метод для вычисления пути дуги
 * @param x координата центра окружности
 * @param y координата центра окружности
 * @param radius  радиус окружности
 * @param startAngle  начальный угол дуги (в градусах)
 * @param endAngle  конечный угол дуги (в градусах)
 * @returns  конечный угол дуги (в градусах)
 */
export const calculateArcPath = (
    x: number,
    y: number,
    radius: number,
    startAngle: number,
    endAngle: number
) => {
    // Преобразуем начальную и конечную точку дуги из полярных координат в декартовые
    // Полярные координаты указываются с углом endAngle и радиусом radius
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);

    // Определяем, рисовать ли большую дугу (больше 180 градусов) или малую дугу (меньше 180 градусов)
    // Для соединения двух точек на окружности
    // Если разница между углами больше 180 градусов, largeArcFlag = '1', иначе '0'

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
};

export const calculateProgress = (
    percent = 0,
    centerX: number,
    centerY: number,
    radius: number,
    fullAngle: number
) => {
    const endAngle = (percent / 100) * fullAngle;
    if (percent === 100) {
        return `
      M ${centerX},${centerY - radius}
      A ${radius},${radius} 0 1,1 ${centerX},${centerY + radius}
      A ${radius},${radius} 0 1,1 ${centerX},${centerY - radius}
    `;
    }
    // Вычисляем конечный угол для дуги

    return calculateArcPath(centerX, centerY, radius, 0, endAngle);
};
